var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vs-breadcrumb',{staticClass:"mb-6",attrs:{"items":[
   {
     title: '权限',
     url: '/auth/node'
   },
   {
     title: '权限节点管理',
     active: true
   }
 ]}}),_c('div',[_c('vs-table',{ref:"table",attrs:{"pagination":"","max-items":_vm.itemsPerPage,"data":_vm.list,"noDataText":_vm.noDataText,"stripe":true},scopedSlots:_vm._u([{key:"default",fn:function(ref){
 var data = ref.data;
return [_c('tbody',_vm._l((data),function(tr,index){return _c('vs-tr',{key:index},[_c('vs-td'),_c('vs-td',[_c('span',{staticClass:"text-bold"},[_vm._v(_vm._s(tr.name))])]),_c('vs-td',[_c('ul',{staticClass:"con-s"},[_c('li',[_c('div',{staticClass:"mb-1"},[_vm._v(_vm._s(Number(tr.status) === 1?'可用':'已禁用'))]),_c('vs-switch',{on:{"input":function($event){return _vm.changeSwitch(tr)}},model:{value:(tr.status),callback:function ($$v) {_vm.$set(tr, "status", $$v)},expression:"tr.status"}})],1)])]),_c('vs-td',[_vm._v(_vm._s(tr.level))])],1)}),1)]}}])},[_c('template',{slot:"thead"},[_c('vs-th',[_vm._v("#")]),_c('vs-th',[_vm._v("节点名称")]),_c('vs-th',[_vm._v("层级")]),_c('vs-th',[_vm._v("状态")])],1)],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }